export default {
    MEDIAMANAGER_URL: 'https://mediamanager.sportnet.online',
};
